import { render, staticRenderFns } from "./VersionCompare.vue?vue&type=template&id=41dc99c4&scoped=true"
import script from "./VersionCompare.vue?vue&type=script&lang=js"
export * from "./VersionCompare.vue?vue&type=script&lang=js"
import style0 from "./VersionCompare.vue?vue&type=style&index=0&id=41dc99c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc99c4",
  null
  
)

export default component.exports